import EventEmitter from './EventEmitter';
import type Timeline from '../Timeline';

/**
 * 交互行为
 */
export const ACTION = {
  /** 播放 */
  PLAY: 'play',
  /** 重播 */
  REPLAY: 'replay',
  /** 暂停 */
  PAUSE: 'pause',
  /** 上一个 */
  PREVIOUS: 'previous',
  /** 下一个 */
  NEXT: 'next'
} as const;

/** 交互行为事件定义 */
export type ActionDefinition = {
  [ACTION.PLAY]: () => void;
  [ACTION.REPLAY]: () => void;
  [ACTION.PAUSE]: () => void;
  [ACTION.PREVIOUS]: () => void;
  [ACTION.NEXT]: () => void;
};

/**
 * 交互行为管理
 */
export default class Action extends EventEmitter<ActionDefinition> {
  /** 时间轴实例 */
  timeline: Timeline;

  constructor(timeline: Timeline) {
    super(Object.values(ACTION));

    this.timeline = timeline;
  }
}
